import Direcciones from './Direcciones'

export default Direcciones
